import { render, staticRenderFns } from "./PlateStockPopularTable.vue?vue&type=template&id=07dbc233&scoped=true"
import script from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
export * from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
import style0 from "./PlateStockPopularTable.vue?vue&type=style&index=0&id=07dbc233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dbc233",
  null
  
)

export default component.exports